import { Injectable } from '@angular/core';
import { UsersProject } from "./user-management.model";
import { Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AuthService, IUserInfo, IUserInProject } from '../shared/core/index';
import 'rxjs/Rx';
import { HttpService } from '../shared/core/http.service';
import { IUser } from './user.model';

@Injectable()
export class UserService {

    private _userInfo: IUserInfo;
    private userServiceUrl = new URL('user', process.env.API_URL).toString();

    constructor(private _httpService: HttpService, private _authService: AuthService) {
        this._authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }

    addUser(user: IUser): Observable<boolean> {
        var body = JSON.stringify(user);
        return this._httpService.httpPost(this.userServiceUrl+'/addUser', body)
            .do((p: Response) => {
                return true;
            })
            .catch(e => {
                console.error('addUser:' + e._body);
                return Observable.of<any>(false);
            });
    }

    patchUser(user: IUser): Observable<boolean> {
        var body = JSON.stringify(user);
        return this._httpService.httpPatch(this.userServiceUrl+'/patchUser', body)
            .do((p: Response) => true)
            .catch(e => {
                console.error('updateUser:' + e._body);
                return Observable.of<any>(false);
            });
    }

    getUser(email: string): Observable<IUser> {
        return this._httpService.httpGet(this.userServiceUrl + '/GetUser?email=' + email)
            .map(res => res.json())
            .do(res => {
               return res;
            }, error => console.error(error));
    }

    extendUser(email: string): Observable<IUser> {
        return this._httpService.httpGet(this.userServiceUrl + '/extend?email=' + email)
            .map(res => {
                return res.json()
            })
            .do(res => {
               return res;
            }, error => {
                console.error(error._body);
            });
    }

    resendUser(email: string): Observable<IUser> {
        return this._httpService.httpGet(this.userServiceUrl + '/resend?email=' + email)
            .map(res => {
                return res.json()
            })
            .do(res => {
               return res;
            }, error => {
                console.error(error._body);
            });
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/users/user.service.ts